module.exports = __webpack_public_path__ + "img/private-03.6132d96c.jpg";